import { useFetchFn } from 'hooks/useFetchFn';
import type { ApiJob } from 'modules/listing/api/job/types/ApiJob';
import { searchAlgoliaFetchSimilarJobs } from 'modules/search/algolia/fetch/similarJobs/searchAlgoliaFetchSimilarJobs';
import { SearchLoadingSectionMockResults } from 'modules/search/components/Loading/SearchLoadingSectionMockResults';
import { useSearchLocationOrEmpty } from 'modules/search/zustand-stores/searchStore';

import { ViewJobPageSidebarSuggestionsHolder } from './ViewJobPageSidebarSuggestions.styled';
import { ViewJobPageSidebarSuggestionsHits } from './ViewJobPageSidebarSuggestionsHits';

type Props = {
  job: ApiJob;
};

export function ViewJobPageSidebarSuggestions({ job }: Props) {
  const userSearchLocation = useSearchLocationOrEmpty();

  const [similarJobsResponse] = useFetchFn({
    fn: searchAlgoliaFetchSimilarJobs,
    args: [
      job.name,
      job.synonym,
      job.functions,
      userSearchLocation,
      job.org?.areasOfFocusKeys,
    ],
    // We don't want to change the results as the user navigates
    // But the search location might load after this functions is called, so make sure to clear it
    cacheKey: userSearchLocation
      ? 'with-search-location'
      : 'without-search-location',
  });

  return (
    <ViewJobPageSidebarSuggestionsHolder>
      {similarJobsResponse ? (
        <ViewJobPageSidebarSuggestionsHits
          jobId={job.id}
          queryID={similarJobsResponse.queryID}
          hits={similarJobsResponse.hits}
          page={similarJobsResponse.page}
          hitsPerPage={similarJobsResponse.nbPages}
        />
      ) : (
        <SearchLoadingSectionMockResults items={3} />
      )}
    </ViewJobPageSidebarSuggestionsHolder>
  );
}
